<template>
	<div class="callback-container">
		<div class="callback-box">
			<div v-if="loading" class="loading-content">
				<i class="el-icon-loading loading-icon"></i>
				<h2 class="loading-title">正在处理登录...</h2>
				<p class="loading-text">{{ statusText }}</p>
			</div>

			<div v-else-if="error" class="error-content">
				<i class="el-icon-circle-close error-icon"></i>
				<h2 class="error-title">登录失败</h2>
				<p class="error-text">{{ errorMessage }}</p>
				<el-button type="primary" @click="retryLogin" class="retry-button">
					重新登录
				</el-button>
			</div>

			<div v-else class="success-content">
				<i class="el-icon-circle-check success-icon"></i>
				<h2 class="success-title">登录成功</h2>
				<p class="success-text">正在跳转到首页...</p>
			</div>
		</div>
	</div>
</template>

<script>
import { signinRedirectCallback } from '@/utils/oidcTestConfig'

export default {
	name: 'OidcTestSignin',
	data() {
		return {
			loading: true,
			error: false,
			errorMessage: '',
			statusText: '正在验证身份信息...'
		}
	},
	created() {
		this.handleCallback()
	},
	methods: {
		async handleCallback() {
			try {
				this.statusText = '正在验证身份信息...'
				
				// 检查URL参数
				const query = this.$route.query
				if (query.error) {
					throw new Error(query.error_description || query.error || '认证失败')
				}
				
				// 处理OIDC回调
				const user = await signinRedirectCallback()
				console.log('OIDC用户信息:', user)
				
				if (user) {
					this.statusText = '登录成功，正在跳转...'
					this.loading = false
					
					// 延迟跳转到首页
					setTimeout(() => {
						this.$router.push('/Acccount/OidcTest')
					}, 1000)
				} else {
					throw new Error('未获取到用户信息')
				}
			} catch (error) {
				console.error('登录回调处理失败:', error)
				this.loading = false
				this.error = true
				this.errorMessage = error.message || '登录验证失败，请重试'
			}
		},
		
		retryLogin() {
			this.$router.push('/Acccount/OidcTest')
		}
	}
}
</script>

<style lang="scss" scoped>
.callback-container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	padding: 20px;
}

.callback-box {
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
	padding: 60px 50px;
	width: 100%;
	max-width: 500px;
	text-align: center;
}

.loading-content,
.error-content,
.success-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.loading-icon,
.error-icon,
.success-icon {
	font-size: 64px;
	margin-bottom: 20px;
}

.loading-icon {
	color: #667eea;
	animation: spin 1s linear infinite;
}

.error-icon {
	color: #f56c6c;
}

.success-icon {
	color: #67c23a;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.loading-title,
.error-title,
.success-title {
	font-size: 24px;
	font-weight: 600;
	margin: 0 0 15px 0;
	color: #333;
}

.loading-text,
.error-text,
.success-text {
	font-size: 16px;
	color: #666;
	margin: 0;
	line-height: 1.6;
}

.retry-button {
	margin-top: 30px;
	padding: 12px 40px;
}
</style>

